import { createContext, useContext } from 'react';
import { Actions } from './enums/Actions';
export const initialState = {
    isMuted: true,
    isLeftSliding: false,
    isRightSliding: false,
    stories: {},
};
export const AppContext = createContext({
    state: initialState,
});
export const useAppContext = () => useContext(AppContext);
const reducer = (state, action) => {
    switch (action.type) {
        case Actions.TOGGLE_AUDIO:
            return Object.assign(Object.assign({}, state), { isMuted: !state.isMuted });
        case Actions.CHANGE_AUDIO_STATUS:
            return Object.assign(Object.assign({}, state), { isMuted: action.payload.isMuted });
        default:
            throw new Error();
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map